var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "titles",
      attrs: {
        inline: true,
        model: _vm.application.titles,
        "label-width": "160px",
        size: "small"
      }
    },
    [
      _c("el-form-item", { attrs: { label: "Τύπος Φοίτησης" } }, [
        _vm._v(_vm._s(_vm.distant))
      ]),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.distant === "Συμβατικός",
              expression: "distant === 'Συμβατικός'"
            }
          ],
          attrs: { label: "Μερική" }
        },
        [_vm._v(_vm._s(_vm.application.titles.partTime ? "Ναι" : "Όχι"))]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.distant === "Εξ αποστάσεως",
              expression: "distant === 'Εξ αποστάσεως'"
            }
          ]
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: " " } },
            [
              _c("el-checkbox", {
                attrs: {
                  label: "Μέρος έγινε στην Ελλάδα",
                  name: "application.titles.partOfStudiesGr",
                  disabled: true
                },
                model: {
                  value: _vm.application.titles.partOfStudiesGr,
                  callback: function($$v) {
                    _vm.$set(_vm.application.titles, "partOfStudiesGr", $$v)
                  },
                  expression: "application.titles.partOfStudiesGr"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.application.titles.partOfStudiesGr,
                  expression: "application.titles.partOfStudiesGr"
                }
              ],
              attrs: { label: "Πόλη" }
            },
            [_vm._v(_vm._s(_vm.application.titles.cityOfStudiesGr))]
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.application.titles.partOfStudiesGr,
                  expression: "application.titles.partOfStudiesGr"
                }
              ],
              attrs: { label: "Ίδρυμα" }
            },
            [_vm._v(_vm._s(_vm.application.titles.institutionOfStudiesGr))]
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.application.degreeType !== "bachelor",
              expression: "application.degreeType !== 'bachelor'"
            }
          ]
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Βασικό Πτυχίο σε" } },
            [
              _c("el-switch", {
                attrs: {
                  "active-text": "Ελληνικό Πανεπιστήμιο",
                  "inactive-text": "Πανεπιστήμιο του εξωτερικού",
                  disabled: true
                },
                model: {
                  value: _vm.application.titles.greekBachelor,
                  callback: function($$v) {
                    _vm.$set(_vm.application.titles, "greekBachelor", $$v)
                  },
                  expression: "application.titles.greekBachelor"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.application.titles.greekBachelor,
                  expression: "application.titles.greekBachelor"
                }
              ],
              attrs: { label: "Τμήμα Πανεπιστημίου" }
            },
            [_vm._v(_vm._s(_vm.application.titles.greekBachelorInserted))]
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.application.titles.greekBachelor,
                  expression: "!application.titles.greekBachelor"
                }
              ],
              attrs: { label: "Πράξη αναγνώρισης" }
            },
            [_vm._v(_vm._s(_vm.application.titles.greekBachelorInserted))]
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.application.degreeType === "master",
                  expression: 'application.degreeType === "master"'
                }
              ],
              attrs: { label: "Με Βαθμολογική Αντιστοίχιση" }
            },
            [_vm._v(_vm._s(_vm.scoreMatchString))]
          )
        ],
        1
      ),
      _c("hr"),
      _vm.application.titles.country.name !== null &&
      _vm.application.titles.country.name !== "other"
        ? _c("el-form-item", { attrs: { label: "Χώρα Σπουδών" } }, [
            _vm._v(_vm._s(_vm.application.titles.country.name))
          ])
        : _vm._e(),
      _vm.application.titles.country.name === "other"
        ? _c("el-form-item", { attrs: { label: "Χώρα Σπουδών" } }, [
            _vm._v(_vm._s(_vm.application.titles.country.countryInserted)),
            _c("div", { staticStyle: { color: "red" } }, [
              _vm._v("Προκειται για ΜΗ ΚΑΤΑΧΩΡΗΜΕΝH Χώρα")
            ])
          ])
        : _vm._e(),
      _c(
        "div",
        [
          _vm.application.titles.university.name !== null &&
          _vm.application.titles.university.name !== "other"
            ? _c(
                "el-form-item",
                { attrs: { label: "Πανεπιστήμιο" } },
                [
                  _vm._v(_vm._s(_vm.application.titles.university.name)),
                  _vm.omotages &&
                  _vm.omotages.university &&
                  _vm.omotages.university[0].accredited === "yes"
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title: "Το ίδρυμα είναι ομοταγές",
                          type: "success",
                          "show-icon": ""
                        }
                      })
                    : _vm._e(),
                  _vm.omotages &&
                  _vm.omotages.university &&
                  _vm.omotages.university[0].accredited === "no"
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title: "Το ίδρυμα δεν είναι ομοταγές",
                          type: "error",
                          "show-icon": ""
                        }
                      })
                    : _vm._e(),
                  _vm.omotages &&
                  _vm.omotages.university &&
                  _vm.omotages.university[0].accredited ===
                    "under investigation"
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title: "Μη κριθέν ίδρυμα",
                          type: "warning",
                          "show-icon": ""
                        }
                      })
                    : _vm._e(),
                  _vm.omotages &&
                  _vm.omotages.university &&
                  _vm.omotages.university[0].accredited ===
                    "No data found for University."
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title:
                            "Δε βρέθηκαν στοιχεία για το συγκεκριμένο ίδρυμα",
                          type: "warning",
                          "show-icon": ""
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.application.titles.university.name === "other"
            ? _c("el-form-item", { attrs: { label: "Πανεπιστήμιο" } }, [
                _vm._v(
                  _vm._s(_vm.application.titles.university.universityInserted)
                ),
                _c("div", { staticStyle: { color: "red" } }, [
                  _vm._v("Προκειται για ΜΗ ΚΑΤΑΧΩΡΗΜΕΝΟ Πανεπιστήμιο")
                ])
              ])
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        [
          _vm.application.titles.college.name !== null &&
          _vm.application.titles.college.name !== "other"
            ? _c(
                "el-form-item",
                { attrs: { label: "Κολλέγιο" } },
                [
                  _vm._v(_vm._s(_vm.application.titles.college.name)),
                  _vm.omotages &&
                  _vm.omotages.college &&
                  _vm.omotages.college[0] &&
                  _vm.omotages.college[0].accredited === "yes"
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title: "Το κολέγιο είναι αναγνωρισμένο",
                          type: "success",
                          "show-icon": ""
                        }
                      })
                    : _vm._e(),
                  _vm.omotages &&
                  _vm.omotages.college &&
                  _vm.omotages.college[0] &&
                  _vm.omotages.college[0].accredited === "no"
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title: "Το κολέγιο δεν είναι αναγνωρισμένο",
                          type: "error",
                          "show-icon": ""
                        }
                      })
                    : _vm._e(),
                  _vm.omotages &&
                  _vm.omotages.college &&
                  _vm.omotages.college[0] &&
                  _vm.omotages.college[0].accredited === "under investigation"
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title: "Μη κριθέν κολέγιο",
                          type: "warning",
                          "show-icon": ""
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.application.titles.college.name === "other"
            ? _c("el-form-item", { attrs: { label: "Κολλέγιο" } }, [
                _vm._v(_vm._s(_vm.application.titles.college.collegeInserted)),
                _c("div", { staticStyle: { color: "red" } }, [
                  _vm._v("Προκειται για ΜΗ ΚΑΤΑΧΩΡΗΜΕΝΟ Κολλέγιο")
                ])
              ])
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        [
          _vm.application.titles.faculty.name !== null &&
          _vm.application.titles.faculty.name !== "other"
            ? _c(
                "el-form-item",
                { attrs: { label: "Σχολή" } },
                [
                  _vm._v(_vm._s(_vm.application.titles.faculty.name)),
                  _vm.omotages &&
                  _vm.omotages.faculty &&
                  _vm.omotages.faculty[0] &&
                  _vm.omotages.faculty[0].accredited === "yes"
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title: "Η σχολή είναι αναγνωρισμένη",
                          type: "success",
                          "show-icon": ""
                        }
                      })
                    : _vm._e(),
                  _vm.omotages &&
                  _vm.omotages.faculty &&
                  _vm.omotages.faculty[0] &&
                  _vm.omotages.faculty[0].accredited === "no"
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title: "Η σχολή δεν είναι αναγνωρισμένη",
                          type: "error",
                          "show-icon": ""
                        }
                      })
                    : _vm._e(),
                  _vm.omotages &&
                  _vm.omotages.faculty &&
                  _vm.omotages.faculty[0] &&
                  _vm.omotages.faculty[0].accredited === "under investigation"
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title: "Μη κριθείσα σχολή",
                          type: "warning",
                          "show-icon": ""
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.application.titles.faculty.name === "other"
            ? _c("el-form-item", { attrs: { label: "Σχολή" } }, [
                _vm._v(_vm._s(_vm.application.titles.faculty.facultyInserted)),
                _c("div", { staticStyle: { color: "red" } }, [
                  _vm._v("Προκειται για ΜΗ ΚΑΤΑΧΩΡΗΜΕΝΗ ΣΧΟΛΗ")
                ])
              ])
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        [
          _vm.application.titles.department.name !== null &&
          _vm.application.titles.department.name !== "other"
            ? _c(
                "el-form-item",
                { attrs: { label: "Τμήμα" } },
                [
                  _vm._v(_vm._s(_vm.application.titles.department.name)),
                  _vm.omotages &&
                  _vm.omotages.department &&
                  _vm.omotages.department[0] &&
                  _vm.omotages.department[0].accredited === "yes"
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title: "Το τμήμα είναι αναγνωρισμένο",
                          type: "success",
                          "show-icon": ""
                        }
                      })
                    : _vm._e(),
                  _vm.omotages &&
                  _vm.omotages.department &&
                  _vm.omotages.department[0] &&
                  _vm.omotages.department[0].accredited === "no"
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title: "Το τμήμα δεν είναι αναγνωρισμένο",
                          type: "error",
                          "show-icon": ""
                        }
                      })
                    : _vm._e(),
                  _vm.omotages &&
                  _vm.omotages.department &&
                  _vm.omotages.department[0] &&
                  _vm.omotages.department[0].accredited ===
                    "under investigation"
                    ? _c("el-alert", {
                        attrs: {
                          closable: false,
                          title: "Μη κριθέν τμήμα",
                          type: "warning",
                          "show-icon": ""
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.application.titles.department.name === "other"
            ? _c("el-form-item", { attrs: { label: "Τμήμα" } }, [
                _vm._v(
                  _vm._s(_vm.application.titles.department.departmentInserted)
                ),
                _c("div", { staticStyle: { color: "red" } }, [
                  _vm._v("Προκειται για ΜΗ ΚΑΤΑΧΩΡΗΜΕΝΟ Τμήμα")
                ])
              ])
            : _vm._e()
        ],
        1
      ),
      _c("hr"),
      _c("el-form-item", { attrs: { label: "Τίτλος Σπουδών" } }, [
        _vm._v(_vm._s(_vm.application.titles.certificationTitle))
      ]),
      _c(
        "div",
        [
          _c("el-form-item", { attrs: { label: "Πιστωτικές Μονάδες" } }, [
            _vm._v(_vm._s(_vm.application.titles.credits))
          ]),
          _c("el-form-item", { attrs: { label: "Διάρκεια Σπουδών" } }, [
            _vm._v(_vm._s(_vm.application.titles.durationOfStudies))
          ]),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.application.degreeType === "bachelor",
                  expression: "application.degreeType === 'bachelor'"
                }
              ],
              attrs: { label: "Συνυποβολή Τίτλου" }
            },
            [
              _c("el-checkbox", {
                attrs: {
                  label: "Επιθυμώ",
                  name: "synektimisi",
                  disabled: "disabled"
                },
                model: {
                  value: _vm.application.consideration,
                  callback: function($$v) {
                    _vm.$set(_vm.application, "consideration", $$v)
                  },
                  expression: "application.consideration"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c("el-form-item", { attrs: { label: "Ημέρ. Εγγραφής" } }, [
            _vm._v(_vm._s(_vm.application.titles.dateOfRegistration))
          ]),
          _c("el-form-item", { attrs: { label: "Ημερ. Αποφοίτησης" } }, [
            _vm._v(_vm._s(_vm.application.titles.dateOfGraduation))
          ])
        ],
        1
      ),
      _c(
        "div",
        [
          _c("el-form-item", { attrs: { label: "Βαθμός πτυχίου" } }, [
            _vm._v(_vm._s(_vm.application.grade))
          ]),
          _c("el-form-item", { attrs: { label: "Χαρακτηρισμός" } }, [
            _vm._v(_vm._s(_vm.application.grade_description))
          ])
        ],
        1
      ),
      _c("hr"),
      _c(
        "el-form-item",
        { attrs: { label: "Οι σπουδές έγιναν" } },
        [
          _c("el-switch", {
            attrs: {
              disabled: true,
              "active-text": "σε περισσότερα Πανεπιστήμια",
              "inactive-text": "σε ένα Πανεπιστήμιο"
            },
            model: {
              value: _vm.application.titles.studiesInMoreUniversities,
              callback: function($$v) {
                _vm.$set(
                  _vm.application.titles,
                  "studiesInMoreUniversities",
                  $$v
                )
              },
              expression: "application.titles.studiesInMoreUniversities"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.application.titles.studiesInMoreUniversities,
              expression: "application.titles.studiesInMoreUniversities"
            }
          ]
        },
        _vm._l(_vm.application.titles.additionalUniversities, function(
          additionalUni,
          index
        ) {
          return _c(
            "div",
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: additionalUni.university != null,
                      expression: "additionalUni.university != null"
                    }
                  ],
                  attrs: { label: "Πανεπιστήμιο" }
                },
                [_vm._v(_vm._s(additionalUni.university))]
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: additionalUni.credits != null,
                      expression: "additionalUni.credits != null"
                    }
                  ],
                  attrs: { label: "Μονάδες" }
                },
                [_vm._v(_vm._s(additionalUni.credits))]
              )
            ],
            1
          )
        })
      ),
      _vm.application.degreeType === "bachelor"
        ? _c(
            "div",
            [
              _c("hr"),
              _vm.application.correspondence == false
                ? _c("el-alert", {
                    attrs: {
                      closable: false,
                      title: "Eπιλογή ΜΟΝΟ Ισοτιμίας",
                      type: "warning",
                      "show-icon": "show-icon"
                    }
                  })
                : _vm._e(),
              _c("br"),
              _c("el-form-item", { attrs: { label: "Αναγνώριση τίτλου με" } }, [
                _vm._v(_vm._s(_vm.isConsideration))
              ]),
              _vm.application.correspondence
                ? _c(
                    "div",
                    [
                      _vm.application.recognitionWith === "aei" ||
                      _vm.application.recognitionWith === "aeiAndTei"
                        ? _c("el-form-item", { attrs: { label: " " } }, [
                            _vm._v(
                              _vm._s(
                                _vm.application.titlesCorrespondence
                                  .universityDepartment.name
                              )
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      this.activeRole === "PreChecker"
        ? _c(
            "el-button",
            {
              attrs: { type: "primary", icon: "el-icon-search", size: "small" },
              on: {
                click: function($event) {
                  _vm.listAllDepartments()
                }
              }
            },
            [_vm._v("Λίστα Ελλ. Ιδρυμάτων")]
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Λίστα Ελληνικών Ιδρυμάτων προς Αντιστοίχιση",
            visible: _vm.showUniList,
            width: "60%"
          },
          on: {
            "update:visible": function($event) {
              _vm.showUniList = $event
            }
          }
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingDepts,
                  expression: "loadingDepts"
                }
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.allDepartments,
                stripe: "stripe",
                border: "border",
                "highlight-current-row": "highlight-current-row",
                height: "350"
              }
            },
            [
              _c("el-table-column", {
                attrs: { label: "Ίδρυμα", width: "300" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("i", { staticClass: "el-icon-news" }),
                        _c("span", { staticStyle: { "margin-left": "10px" } }, [
                          _vm._v(_vm._s(scope.row.institution_name))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "Τμήμα", width: "350" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("i", { staticClass: "el-icon-management" }),
                        _c("span", { staticStyle: { "margin-left": "10px" } }, [
                          _vm._v(_vm._s(scope.row.department_name))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d7ff08c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d7ff08c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Titles.vue
// module id = null
// module chunks = 